import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IPerson } from '../Models/IPerson';
import { ITypedValidationResult } from '../Models/IValidationResult';

class personService extends BaseApiService {
    public constructor() {
        super('Person/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByPersonId(personId: number, auth0Id: string): Promise<IPerson> {
        return this.httpClient.get<IPerson>(`GetByPersonId?personId=${personId}&auth0Id=${auth0Id}`, personService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getByParticipantPortalUserId(participantPortalUserId: number, auth0Id: string): Promise<IPerson> {
        return this.httpClient.get<IPerson>(`GetByParticipantPortalUserId?participantPortalUserId=${participantPortalUserId}&auth0Id=${auth0Id}`, personService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async savePerson(person: IPerson, auth0Id: string) {
        console.log('Updating Person');
        this.httpClient.post<ITypedValidationResult<IPerson>>(`SavePerson?auth0Id=${auth0Id}`, person, personService.config).catch(this.handleError.bind(this));
    }

}

export const PersonService: personService = new personService();